import * as React from 'react';
import { jsx, css, keyframes } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import { setTime, wait } from 'Src/me/pages/guest/proposals/new/utils';
import type { CheckboxAnswerType } from '../../../../../../../chat/views/types';
import type { CheckboxGroupPropsType } from '../..';
import { DisabledSvg } from '../../assets/Disabled.svg';
import { CheckedSvg } from '../../assets/Checked.svg';
import { DefaultSvg } from '../../assets/Default.svg';

const CHANGE_COUNT = 0;

const { tablet, mobile } = mediaQueries();

type CheckboxButtonPropsType = Merge<CheckboxGroupPropsType & Required<CheckboxAnswerType> & {
  isAnswered: boolean;
  setCheckedAnswerIds: React.Dispatch<React.SetStateAction<number[]>>;
}>;

export const CheckboxButton = ({
  keyName,
  id,
  value,
  textContents,
  gaEventName,
  checked,
  isAnswered,
  setCheckedAnswerIds,
}: CheckboxButtonPropsType) => {
  const [isChecked, setIsChecked] = React.useState<boolean>(checked);

  const onChangeHandler = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    // チェック状態を変更
    setIsChecked((prev) => !prev);
  }, []);

  React.useEffect(() => {
    setCheckedAnswerIds((prev) => {
      const checkedAnswerIds = [...prev];
      if (isChecked) {
        checkedAnswerIds.push(id);
      } else {
        const index = checkedAnswerIds.indexOf(id);
        if (index > -1) {
          checkedAnswerIds.splice(index, 1);
        }
      }

      return checkedAnswerIds;
    });
  }, [id, setCheckedAnswerIds, isChecked]);

  return (
    <div
    >
      <input
        type="checkbox"
        id={`${keyName}_checkbox_${id}`}
        checked={isChecked}
        value={value}
        onChange={onChangeHandler}
        css={css`
          display: none;
        `}
      />
      <label
        id={`ga_event_${gaEventName}_${id}`}
        htmlFor={`${keyName}_checkbox_${id}`}
        css={css`
          color: #041156;
          font-size: 20px;
          font-weight: bold;
          padding: 14px 1em 14px 75px;
          background-color: #fff;
          border-radius: 10px;
          position: relative;
          cursor: pointer;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            font-size: ${setAutomaticDesignBasedSize(20, 16)};
            padding: 14px 1em 14px ${setAutomaticDesignBasedSize(75, 38)};
          `)}

          ${isAnswered && css`
            pointer-events: none;
          `}

          ${isChecked ? css`
            color: #041156;
            background-color: #fff7c9;
          ` : (isAnswered && css`
            background-color: #e1e1e1;
            color: #bfbfbf;
          `)}
        `}
      >
        <span
          css={css`
            content: "";
            font-size: 0;
            width: 22px;
            position: absolute;
            top: 50%;
            left: 35px;
            transform: translateY(-50%);

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              width: ${setAutomaticDesignBasedSize(22, 16)};
              left: ${setAutomaticDesignBasedSize(35, 14)};
            `)}
          `}
        >
          {isChecked ? <CheckedSvg /> : (
            <>
              {isAnswered ? <DisabledSvg /> : <DefaultSvg />}
            </>
          )}
        </span>
        {textContents}
      </label>
    </div>
  );
};
